import React from 'react';
import {PasswordValidator} from 'Validation.jsx';
import * as dataUrls from "../../wwwroot/js/dataUrls"

class UserResetPassword extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.handleCurrentChange = this.handleCurrentChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleConfirmChange = this.handleConfirmChange.bind(this);
        this.handleValidation = this.handleValidation.bind(this);

        this.handleResetPassword = this.handleResetPassword.bind(this);
        this.resetPassword = this.resetPassword.bind(this);
    }

    handleCurrentChange(event) {
        this.setState({ current: event.target.value });
    }

    handlePasswordChange(event) {
        this.setState({ password: event.target.value });
    }

    handleConfirmChange(event) {
        this.setState({ confirm: event.target.value });
    }

    handleValidation(password, confirm) {
        return !this.passwordValidator.evaluateErrors(password, confirm);
    }

    handleResetPassword() {
        if (this.handleValidation(this.state.password, this.state.confirm)) {
            var url = dataUrls.Standard_Login_ConfirmPassword(this.state.current);

            var xhr = new XMLHttpRequest();
            xhr.open("get", url, true);
            xhr.setRequestHeader('Content-Type', 'application/json');

            xhr.onload = function () {

                if (xhr.status === 200) {
                    var data = JSON.parse(xhr.responseText);

                    if (data.successful === true) {
                        this.resetPassword();
                    } else {
                        this.setState({
                            success: null,
                            error: "Current password is incorrect"
                        });
                    }
                } else {
                    this.setState({
                        success: null,
                        error: "Password update failed"
                    });
                }

            }.bind(this);         

            xhr.send();
        }
    }

    resetPassword() {
        this.setState({
            error: null,
            success: null
        });

        
            var url = dataUrls.Standard_Login_ResetPassword(this.state.password);

            var xhr = new XMLHttpRequest();
            xhr.open("put", url, true);
            xhr.setRequestHeader('Content-Type', 'application/json');

            xhr.onload = function () {
                    if (xhr.status === 200) {
                        this.setState({
                            error: null,
                            success: "Password updated"
                        });
                    } else {
                        this.setState({
                            success: null,
                            error: "Password update failed"
                        });
                        console.log(xhr.status);
                        console.log(xhr.responseText);
                    }
            }.bind(this);

            xhr.send();
        
    }

    render() {
        return (
            <div className="well-area">
                <div className="col-md-6">
                <div className="gap-bottom row">
                    <div className="col-md-12">
                        <div className="input-group" style={{ width: "100%" }}>
                            <span className="has-float-label">
                        <input type="password" id="password" className="form-control" onChange={this.handleCurrentChange} placeholder="Current Password"/>
                        <label htmlFor="password">Current Password&nbsp;<span className="text-danger">*</span></label>
                            </span>
                            </div>
                </div></div>
                <div className="gap-bottom row">
                    <div className="col-md-12">
                        <div className="input-group" style={{ width: "100%" }}>
                            <span className="has-float-label">
                        <input type="password" id="password" className="form-control" onChange={this.handlePasswordChange} placeholder="New Password"/>
                        <label htmlFor="password">New Password&nbsp;<span className="text-danger">*</span></label>
                            </span>
                            </div>
                    </div></div>
                <div className="gap-bottom row">
                    <div className="col-md-12">
                        <div className="input-group" style={{ width: "100%" }}>
                            <span className="has-float-label">
                        <input type="password" id="confirm" className="form-control" onChange={this.handleConfirmChange} placeholder="Confirm New Password" />
                        <label htmlFor="confirm">Confirm New Password&nbsp;<span className="text-danger">*</span></label>
                            </span>
                            </div>
                        <PasswordValidator
                            ref={instance => { this.passwordValidator = instance; }}
                            enabled={true} />
                    </div>
                </div>
                <div className="gap-bottom row">
                    <div className="col-md-12" style={{marginLeft:"10px"}}>
                        <input type="button" value="Reset Password" className="btn btn-success" onClick={this.handleResetPassword} />
                    </div>
                </div>

            {this.state.error
                ? <div className="alert alert-danger col-12">{this.state.error}</div>
                : <div></div>}
            {this.state.success
                ? <div className="alert alert-success col-12">{this.state.success}</div>
                        : <div></div>}
                    </div>
        </div>);
    }
}

export default UserResetPassword;


// WEBPACK FOOTER //
// ./src/Standard/ResetPassword.jsx